import React from 'react';
import { Link } from 'react-router-dom';
import { IMAGES, bgStyle } from '@/config/images';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Wrench, ArrowRight } from 'lucide-react';

const Print3DTools = () => {
  return (
    <div
      className="min-h-screen -m-4 lg:-m-6 p-4 lg:p-6"
      style={bgStyle(IMAGES.PRINTING3D_DASHBOARD)}
    >
      <div className="fixed inset-0 bg-black/70 -z-10" style={{ pointerEvents: 'none' }} />

      <div className="max-w-4xl mx-auto space-y-6">
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-orange-500 mb-2">Tools</div>
          <h1
            className="text-3xl md:text-4xl font-bold text-orange-500 tracking-tight uppercase"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            My Tools
          </h1>
          <p className="mt-2 text-sm text-zinc-300">
            Your personal 3D printing tool and accessory library.
          </p>
        </div>

        <Card className="bg-black/60 border-zinc-700">
          <CardContent className="py-10 text-center space-y-4">
            <Wrench className="w-12 h-12 text-zinc-600 mx-auto" />
            <h3 className="text-white font-bold text-lg">No Tools Configured</h3>
            <p className="text-zinc-400 text-sm">Add your 3D printing tools and accessories here to keep your setup organised.</p>
            <Link to="/3d-printing/equipment">
              <Button className="bg-[#c85a00] hover:bg-[#a84800] text-white">
                Go to My Equipment
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Print3DTools;
